module.exports = __webpack_public_path__ + "img/rocket.25da1cc.png";